import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import properties from '../../constants/Properties';
import { changeContextMode } from '../../actions/MenuActions';
import { changeAcoordionWidth } from '../../actions/AccordionActions';
import { updateCurrentSlide } from '../../actions/ProductionActions';
import modeType from '../../constants/ModeConstants';
import mouseUtils from '../../components/utils/MouseUtils';
import zoomUtils from '../../components/utils/ZoomUtils';
import playController from '../utils/PlayController';
import hoverManager from '../utils/HoverManager';
import helpUtils from '../utils/HelpUtils';
import appParameters from '../utils/AppParameters';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import platformDetection from '../utils/PlatformDetection';
import apiServiceUtils from '../utils/ApiServiceUtils';
import locales from "../../locales/LocalesManager";

const SaveButtonAudioEditorContent = React.createClass({
    getInitialState () {
        return {
            isSaveButtonOver: false,
            isHelpButtonOver: false
        };
    },
    onSaveMouseIn () {
        hoverManager.show(this.refs.holder, 'saveButton', 'left');

        this.setState({
            isSaveButtonOver: true
        });
    },
    onSaveMouseOut () {
        hoverManager.hide();

        this.setState({
            isSaveButtonOver: false
        });
    },
    onSaveClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        zoomUtils.closeZoom();

        if (document.activeElement)
            document.activeElement.blur();

        if (playController.isAudioEditorMode())
            this.props.dispatch(changeAcoordionWidth(properties.BROWSER_WIDTH));

        if (appParameters.context != modeType.AUDIO_TOOL)
            this.props.dispatch(updateCurrentSlide());

        this.props.dispatch(changeContextMode(modeType.SAVE_CONTEXT));
    },
    onHelpMouseIn() {
        hoverManager.show(this.refs.help, 'helpButton', 'left');

        this.setState({
            isHelpButtonOver: true
        });
    },
    onHelpMouseOut() {
        hoverManager.hide();

        this.setState({
            isHelpButtonOver: false
        });
    },
    onHelpClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var url;

        if (appParameters.locale.indexOf('nb_NO') != -1 || appParameters.locale.indexOf('nn_NO') != -1)
            url = 'https://web.creaza.com/no/help/cartoonist';
        else
        if (appParameters.locale.indexOf('sv_SE') != -1)
            url = 'https://web.creaza.com/se/help/skapatecknadserie';
        else
            url = 'https://web.creaza.com/en/help/create-a-cartoon';


        window.open(url, '_blank');
    },
    render () {
        if (this.props.contextMode == modeType.FREEHAND_CONTEXT || this.props.contextMode == modeType.LINE_CONTEXT || this.props.contextMode == modeType.ANIMATION_CONTEXT)
            return (<div/>);

        if (!audioToolUtils.isAudioTool())
            helpUtils.checkHelpInfo();

        var width = properties.INSERT_MENU_BUTTON_SIZE - 10;
        var height = properties.CLIPART_BUTTON_HEIGHT;
        var iconColor;

        if (platformDetection.isIOS()) {
            width = properties.INSERT_MENU_BUTTON_SIZE;
            height = height + 10;
        }

        if (this.state.isSaveButtonOver == true)
            iconColor = '#c0c0c0';
        else
            iconColor = 'white';

        var topBarHeight = apiServiceUtils.getNoInternetConnectionAlertHeight();

        const holderStyle = {
            position: 'absolute',
            left: this.props.windowWidth - this.props.accordionWidth - width,
            top: topBarHeight,
            width: width,
            height: height,
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            zIndex: 1000
        };

        const saveButtonStyle = {
            position: 'absolute',
            left: 0,
            top: 0,
            width: width,
            height: height,
            background: properties.INSERT_MENU_BUTTON_COLOR,
            borderTopLeftRadius: 50,
            borderBottomLeftRadius: 50,
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        var saveIconStyle = {
            position: 'absolute',
            top: 7,
            left: 11,
            color: iconColor
        };

        var preloaderBackground = properties.INSERT_MENU_BUTTON_COLOR;
        var preloaderVisible = 'none';

        if (this.props.showSavePreloader == true)
            preloaderVisible = 'block';

        const saveSoundPreloader = {
            position: 'absolute',
            left: 0,
            top: 0,
            width: width,
            height: height,
            background: preloaderBackground,
            borderColor: properties.INSERT_MENU_BUTTON_COLOR,
            borderTopLeftRadius: 50,
            borderBottomLeftRadius: 50,
            display: preloaderVisible
        };

        var savePreloaderStyle = {
            position: 'absolute',
            top: 6,
            left: 9,
            color: 'white'
        };

        var src;

        if (this.state.isHelpButtonOver == true)
            src = appParameters.RESOURCES_LOCATION() + 'assets/tutorial_hover.svg';
        else
            src = appParameters.RESOURCES_LOCATION() + 'assets/tutorial.svg';

        var helpStyle = {
            position: 'absolute',
            top: 32,
            width: 26,
            height: 26,
            left: 3
        };

        var preloaderClass = 'fa fa-spinner fa-pulse fa-1x';

        if (audioToolUtils.isAudioTool() || platformDetection.isIOSApp())
            helpStyle.display = 'none';

        if (platformDetection.isIOS()) {
            saveIconStyle.left = 16;
            savePreloaderStyle.left = 13;
            helpStyle.left = 6;

            saveIconStyle.top = 11;
            savePreloaderStyle.top = 4;
            savePreloaderStyle.left = 6;
            helpStyle.width = 33;
            helpStyle.height = 33;
            helpStyle.top = height + 4;

            preloaderClass = 'fa fa-spinner fa-pulse fa-2x';
        }

        return (
            <div style={holderStyle}>
                <button ref='holder' aria-label={locales.getCaption('SaveMenuTitle', 'save')} style={saveButtonStyle} onTouchEnd={this.onSaveClick} onClick={this.onSaveClick} onMouseOver={this.onSaveMouseIn} onMouseOut={this.onSaveMouseOut}>
                    <i style={saveIconStyle} className="fa fa-floppy-o"></i>
                </button>
                <div style={saveSoundPreloader}>
                    <i style={savePreloaderStyle} className={preloaderClass} />
                </div>

                <img alt='' aria-hidden='true' style={helpStyle} id="helpButton" ref='help' src={src} onTouchEnd={this.onHelpClick} onClick={this.onHelpClick} onMouseOver={this.onHelpMouseIn} onMouseOut={this.onHelpMouseOut}/>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const showSavePreloader = state.menu.showSavePreloader;
    const contextMode = state.menu.contextMode;

    return {
        showSavePreloader,
        contextMode
    };
}

export const SaveButtonAudioEditor = connect(mapStateToProps)(SaveButtonAudioEditorContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/SaveButtonAudioEditor.js
 **/